<template>
    <div class="component">
        <div class="grid grid-cols-12">
            <div class="col-span-12">
                <template v-for="(entry, index) in data.foldOuts" :key="index">
                    <ElementAccordion @isOpen="isOpen">
                        <template v-slot:header>
                            <h2 :class="{'md:!text-green': active}" class="text-sm uppercase">{{entry.title}} <span v-if="entry.titleEnglish" class="font-serif">/</span> <span :class="{'md:!text-green': active}" class="text-gray-dark group-hover:md:text-green transition duration-200" v-if="entry.titleEnglish">{{entry.titleEnglish}}</span></h2>
                        </template>
                        <template v-slot:content>
                            <Text :data="entry"/>
                        </template>
                    </ElementAccordion>
                </template>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        required: true
    }
});

const active = ref(false)
const isOpen = (bool) => {
    active.value = bool
}
</script>